/* Thin fetch wrappers around the TM API endpoints. */

import { ApiBulkImportResult, ApiMapSummary, ApiParsedReplay, ApiPlayerSummary, ApiReplaySummary } from './types';

// Base URL of the SindreMA_Home_Api. Override at build time with
// REACT_APP_TM_API_BASE for dev / staging.
const API_BASE =
  process.env.REACT_APP_TM_API_BASE?.replace(/\/$/, '') ||
  'https://api.sindrema.com';

async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, init);
  if (!res.ok) {
    let detail = '';
    try { detail = await res.text(); } catch {}
    throw new Error(`API ${res.status} ${res.statusText} — ${path}${detail ? ': ' + detail.slice(0, 200) : ''}`);
  }
  return res.json() as Promise<T>;
}

export function parseReplayUrl(gbxUrl: string): Promise<ApiParsedReplay> {
  return jsonFetch<ApiParsedReplay>(`/api/tm/replay/parse?url=${encodeURIComponent(gbxUrl)}`);
}

export function listReplays(limit = 200, challengeUid?: string): Promise<ApiReplaySummary[]> {
  const qs = challengeUid
    ? `limit=${limit}&challengeUid=${encodeURIComponent(challengeUid)}`
    : `limit=${limit}`;
  return jsonFetch<ApiReplaySummary[]>(`/api/tm/replays?${qs}`);
}

export function listMaps(): Promise<ApiMapSummary[]> {
  return jsonFetch<ApiMapSummary[]>(`/api/tm/maps`);
}

export function listPlayers(minReplays = 1): Promise<ApiPlayerSummary[]> {
  return jsonFetch<ApiPlayerSummary[]>(`/api/tm/players?minReplays=${minReplays}`);
}

export function getReplay(ghostUid: string): Promise<ApiParsedReplay> {
  return jsonFetch<ApiParsedReplay>(`/api/tm/replays/${encodeURIComponent(ghostUid)}`);
}

export function deleteReplay(ghostUid: string): Promise<void> {
  return fetch(`${API_BASE}/api/tm/replays/${encodeURIComponent(ghostUid)}`, { method: 'DELETE' })
    .then((res) => {
      if (!res.ok && res.status !== 404) throw new Error(`API ${res.status} ${res.statusText}`);
    });
}

export function bulkImportFromExchange(trackOrUrl: string, count: number): Promise<ApiBulkImportResult> {
  const qs = `track=${encodeURIComponent(trackOrUrl)}&count=${count}`;
  return jsonFetch<ApiBulkImportResult>(`/api/tm/import/exchange?${qs}`, { method: 'POST' });
}
